// extracted by mini-css-extract-plugin
export default {"container":"El-z","bubbleNav":"Fl-z","graphic":"Gl-z","contact":"Hl-z"};